export class Feature {
  constructor(code, enabled, value = null) {
    /** @private */
    this._code = code;
    /** @private */
    this._enabled = enabled;
    /** @private */
    this._value = value;
  }

  /**
   * @returns {boolean}
   */
  get enabled() {
    return this._enabled;
  }

  get value() {
    return this._value;
  }
}
